<!-- CONTENEDOR PRINCIPAL.  -->
<div id="qwebprinter-container" class="container_qsigner">
  <!-- LOADING GENERAL. -->
  <div id="loading-data" class="qsigner-loading" *ngIf="loadingData">
    <div class="spiner-example">
      <!-- Texto. -->
      <div class="text-center">
        <h1>{{ getting_information_label }}</h1>
      </div>
      <!-- Spinner. -->
      <div class="sk-spinner sk-spinner-three-bounce">
        <div class="sk-bounce1"></div>
        <div class="sk-bounce2"></div>
        <div class="sk-bounce3"></div>
      </div>
    </div>
  </div>

  <!-- LOADING DOCUMENTO PDF. -->
  <div class="qsigner-documents-loading" *ngIf="loadingDocument">
    <div class="spiner-example">
      <!-- Texto. -->
      <div class="text-center">
        <h1>{{ 'GETTING_DOCUMENT' | translate }}</h1>
      </div>
      <!-- Spinner. -->
      <div class="sk-spinner sk-spinner-three-bounce">
        <div class="sk-bounce1"></div>
        <div class="sk-bounce2"></div>
        <div class="sk-bounce3"></div>
      </div>
    </div>
  </div>

  <!-- PANTALLA INICIAL: LISTADO DE DOCUMENTOS. -->
  <div class="card card_qsigner" *ngIf="!loadingData && showDocumentList">
    <div id="container-documentlist" class="container animated fadeInDown">
      <!-- Contenido. -->
      <div id="container-documentlist-content" class="row mt-2">
        <!-- Bloque de cabecera. -->
        <div id="container-documentlist-content-header" class="col-12 text-center">
          <!-- Titulo.  -->
          <h2>
            {{ available_documents_label }} <span class="badge badge-pill badge-primary">{{ documentos?.documents?.length }}</span>
          </h2>
          <!-- Subtitulo.  -->
          <p>{{ available_documents_description_label }}</p>
        </div>

        <!-- Bloque para la lista de documentos. -->
        <div id="container-documentlist-content-body" class="col-12 text-center">
          <!-- Bloque para cada documento de la lista.  -->
          <div *ngFor="let document of documentos.documents; let i = index" class="row">
            <!-- Etiqueta.  -->
            <label>
              <!-- Checkbox  -->
              <input
                id="file-{{ document.documentId }}"
                type="checkbox"
                class="radiobtn form-checkbox checkbox-fix component-style check-style"
                [(ngModel)]="modelo['file-' + document.documentId]"
                value="{{ i }}"
                (ngModelChange)="changeSelectFiles('file-' + document.documentId)"
              />
              <!-- Texto.  -->
              <p class="document-list-valign">
                {{ document.description }}
              </p>
            </label>
          </div>

          <!-- Botón: Obtener información. -->
          <div class="col-12 col-sm-offset-1 text-center m-t">
            <button id="btn_continue" type="button" class="btn btn-primary" (click)="obtenerInfo()" [disabled]="!checkedDocuments">
              <ng-container *ngIf="!loadingDataWebPrinter">
                {{ continue_label }}
              </ng-container>
            </button>
          </div>
        </div>
      </div>
    </div>
    <i class="fa-thin fa-file-contract"></i>
  </div>

  <!-- BANNERS. -->
  <!-- <div *ngIf="hasBanners" class="container animated fadeInDown m-t">
    <div class="row ibox-content col-sm-10 col-sm-offset-1">
      <div class="text-center">
        <div *ngFor="let banner of bannerList; index as i">
          <img [src]="banner" class="banner" [ngClass]="{ 'm-t': i > 0 }" />
        </div>
      </div>
    </div>
  </div> -->

  <!-- DATA.  -->
  <div class="card card_qsigner" *ngIf="!loadingDataWebPrinter && showData">
    <!-- BARRA DE MENU SUPERIOR.  -->
    <div class="appBottomMenu">
      <!-- Enlace: Ver documentos  -->
      <a id="btn-pdf" class="item" style="pointer-events: auto; opacity: 1" data-toggle="modal" data-target="#exampleModal" (click)="showDocuments()">
        <div>
          <!-- Icono  -->
          <i class="fa-light fa-eye fa-3x color-primary"></i>
        </div>
      </a>
      <!-- Enlace: Continuar  -->
      <a id="btn-next" class="item" style="pointer-events: auto; opacity: 1" (click)="changeDocument()">
        <div>
          <!-- Icono  -->
          <i *ngIf="loadingSendDocuments" class="fa-light fa-spinner fa-spin fa-3x color-primary"></i>
          <i *ngIf="!loadingSendDocuments" class="fa-light fa-right fa-3x color-primary"></i>
        </div>
      </a>
    </div>
    <!-- Contenedor general. -->
    <div>
      <div id="container-data" class="animated fadeInDown text-center" *ngIf="documents">
        <!-- Contenido general. -->
        <div id="container-data-content">
          <!-- DOCUMENTOS PDF. -->
          <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h2 class="modal-title" id="exampleModalLabel">{{ document_label }}</h2>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body py-4">
                  <!-- LOADING DOCUMENTO PDF. -->
                  <div class="qsigner-documents-loading" *ngIf="loadingDocument">
                    <div class="spiner-example">
                      <!-- Texto. -->
                      <div class="text-center">
                        <h1>{{ 'GETTING_DOCUMENT' | translate }}</h1>
                      </div>
                      <!-- Spinner. -->
                      <div class="sk-spinner sk-spinner-three-bounce">
                        <div class="sk-bounce1"></div>
                        <div class="sk-bounce2"></div>
                        <div class="sk-bounce3"></div>
                      </div>
                    </div>
                  </div>
                  <div id="loading-data" class="qsigner-loading" *ngIf="!showDocumentPdf">
                    <div class="spiner-example">
                      <!-- Texto. -->
                      <div class="text-center">
                        <h1>{{ 'GETTING_DOCUMENT' | translate }}</h1>
                      </div>
                      <!-- Spinner. -->
                      <div class="sk-spinner sk-spinner-three-bounce">
                        <div class="sk-bounce1"></div>
                        <div class="sk-bounce2"></div>
                        <div class="sk-bounce3"></div>
                      </div>
                    </div>
                  </div>
                  <ng-container *ngIf="hasDocument && showDocumentPdf">
                    <div id="container-data-pdf" class="row">
                      <!-- Bloque de titulo.  -->
                      <div class="col-12 text-center">
                        <div class="text-center">
                          <!-- Titulo -->
                          <h3 class="mt-2">
                            {{ printed_label }}
                            <!-- Descripción.  -->
                            <span *ngIf="documents.description">
                              {{ documents.description }}
                            </span>
                            <!-- No description -> document from POST -->
                            <span *ngIf="!documents.description"> {{ signed_label }} </span>
                          </h3>
                          <!-- Resumen -->
                          <p>
                            {{ it_has_a_total_of_label }}
                            <strong>{{ totalPages }}</strong> {{ pages_to_review_label }}:
                          </p>
                        </div>
                      </div>
                      <!-- Bloque del PDF.  -->
                      <div class="col-12">
                        <!-- BARRA DE NAVEGACIÓN DE LOS PDFs. (Superior) -->
                        <div class="text-center pagination_qsigner my-3">
                          <!-- Imprimir. -->
                          <button class="btn btn-primary hidden-xs" type="button" (click)="printDocument($event)">
                            <i class="fa-thin fa-print"></i>
                          </button>
                          <div>
                            <!-- Página anterior. -->
                            <button class="btn btn-primary hidden-xs" type="button" (click)="prevPage()" [disabled]="page === 1 || !page || !totalPages">
                              <i class="fa-thin fa-chevrons-left"></i>&nbsp;
                            </button>

                            <!-- Paginación. -->
                            <button class="btn btn-pagination hidden-xs" type="button" disabled>
                              <strong>{{ page }}</strong> / {{ totalPages }}
                            </button>

                            <!-- Página siguiente. -->
                            <button class="btn btn-primary hidden-xs" type="button" (click)="nextPage()" [disabled]="page >= totalPages || !page || !totalPages">
                              &nbsp;<i class="fa-thin fa-chevrons-right"></i>
                            </button>
                          </div>

                          <div>
                            <!-- Aumentar zoom. -->
                            <button class="btn btn-primary hidden-xs" type="button" (click)="zoom_out()" [disabled]="zoom === 1 || !page || !totalPages">
                              <i class="fa-thin fa-magnifying-glass-minus"></i>&nbsp;
                            </button>

                            <!-- Disminuir zoom. -->
                            <button class="btn btn-primary hidden-xs" type="button" (click)="zoom_in()" [disabled]="zoom === 3 || !page || !totalPages">
                              <i class="fa-thin fa-magnifying-glass-plus"></i>&nbsp;
                              <!-- {{ zoom }} -->
                            </button>
                          </div>
                        </div>
                        <!-- PDF visor. -->
                        <div id="container-pdf-viwer">
                          <pdf-viewer
                            [src]="pdfSrc"
                            [render-text]="true"
                            [safe]="true"
                            [original-size]="true"
                            [show-all]="false"
                            [page]="page"
                            [zoom]="zoom"
                            [fit-to-page]="true"
                            (after-load-complete)="afterLoadComplete($event)"
                          ></pdf-viewer>
                        </div>

                        <!-- BARRA DE NAVEGACIÓN DE LOS PDFs. (Inferior) -->
                        <div class="text-center pagination_qsigner mt-3">
                          <!-- Imprimir. -->
                          <button class="btn btn-primary hidden-xs" type="button" (click)="printDocument($event)">
                            <i class="fa-thin fa-print"></i>
                          </button>
                          <div>
                            <!-- Página anterior. -->
                            <button class="btn btn-primary hidden-xs" type="button" (click)="prevPage()" [disabled]="page === 1 || !page || !totalPages">
                              <i class="fa-thin fa-chevrons-left"></i>&nbsp;
                            </button>

                            <!-- Paginación. -->
                            <button class="btn btn-pagination hidden-xs" type="button" disabled>
                              <strong>{{ page }}</strong> / {{ totalPages }}
                            </button>

                            <!-- Página siguiente. -->
                            <button class="btn btn-primary hidden-xs" type="button" (click)="nextPage()" [disabled]="page >= totalPages || !page || !totalPages">
                              &nbsp;<i class="fa-thin fa-chevrons-right"></i>
                            </button>
                          </div>

                          <div>
                            <!-- Aumentar zoom. -->
                            <button class="btn btn-primary hidden-xs" type="button" (click)="zoom_out()" [disabled]="zoom === 1 || !page || !totalPages">
                              <i class="fa-thin fa-magnifying-glass-minus"></i>&nbsp;
                            </button>

                            <!-- Disminuir zoom. -->
                            <button class="btn btn-primary hidden-xs" type="button" (click)="zoom_in()" [disabled]="zoom === 3 || !page || !totalPages">
                              <i class="fa-thin fa-magnifying-glass-plus"></i>&nbsp;
                              <!-- {{ zoom }} -->
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>

          <!-- FIRMAS Y AUTORIZACIONES. -->
          <ng-container>
            <div
              class="row"
              id="SignAuthorizationBlock"
              [ngStyle]="{
                'pointer-events': !blockBody === false ? 'none' : 'auto',
                opacity: !blockBody === false ? '0.4' : '1',
                display: hideElements === false ? 'inherit' : 'none'
              }"
            >
              <!-- Bloque de autorizaciones y firmas.  -->
              <div class="col-12 col-sm-offset-1">
                <!-- TÍTULO DE AUTORIZACIONES Y FIRMAS.  -->
                <div class="text-center m-t m-b">
                  <h2 class="title_card">
                    <ng-container *ngIf="documents && documents.signatures">
                      {{ sing_title_label }}
                      <span class="badge badge-pill badge-primary">{{ currentDocument + 1 }} / {{ totalDocuments }}</span>
                    </ng-container>
                  </h2>
                  <h3 *ngIf="documents.description">{{ documents.description }}</h3>
                </div>

                <!-- AUTORIZACIONES -->
                <div id="authorizations-container" *ngIf="documents && documents.authorization && requiereCustomer === 'true'" class="m-t-lg">
                  <!-- Contenido  -->
                  <div *ngFor="let authorization of documents.authorization; let i = index">
                    <!-- AUTORIZACIONES  -->
                    <a (click)="ocultarTabsetss(authorization.authorizationId)">
                      <div class="list-element">
                        <ng-container *ngIf="authorization['title']">
                          <span class="col-8 ml-0 pl-0">{{ authorization.title }}</span>
                        </ng-container>
                        <em *ngIf="!authorization['title']">
                          {{ without_title_label }}
                        </em>
                        <span *ngIf="authorization['requiredAuthentication']" class="badge badge-warning required">
                          {{ mandatory_fields_label }}
                        </span>
                        <!-- Icono.  -->
                        <i *ngIf="authorization['visible'] === true" class="fa-thin fa-chevron-up fa-x2 iconsize"></i>
                        <i *ngIf="authorization['visible'] === false" class="fa-thin fa-chevron-down fa-x2 iconsize quiter-color"></i>
                      </div>
                    </a>
                    <div
                      id="{{ authorization.authorizationId }}"
                      class="panel-collapse container-question-list"
                      [ngClass]="{
                        collapse: !authorization['visible']
                      }"
                    >
                      <!-- SWITCH: Se hace un switch siempre van a ser 5 tipos *preguntar si existe el tipo 0 -->
                      <div [ngSwitch]="authorization.authorizationType" id="authorization.authorizationId" class="question-list">
                        <!-- Tipo 1: si o no. devuelvo lo que me llegue en el fixed value -->
                        <ng-container *ngSwitchCase="1">
                          <div id="tab-{{ authorization.authorizationId }}" #info class="row form-group switch-type">
                            <!-- Label  -->
                            <div class="col-12 text-left d-flex justify-content-between">
                              <label class="text-left col-form-label">
                                {{ decodeHtmlEntities(authorization.authorizationText) }}
                              </label>
                              <!-- Boton de borrar  -->
                              <button
                                *ngIf="model[authorization.authorizationId]"
                                class="btn btn-outline-danger btn-noborder"
                                type="button"
                                id="button-borrar{{ authorization.authorizationId }}"
                                (click)="borrarAuthorization('radio-' + authorization.authorizationId)"
                              >
                                <i class="fa-thin fa-undo"></i>
                              </button>
                            </div>
                            <!-- Bloque de si o no  -->
                            <div class="col-12 switch-type-boolean text-left">
                              <div class="col-xs-offset-3">
                                <label>
                                  <input
                                    id="{{ authorization.authorizationId }}"
                                    type="radio"
                                    class="radiobtn form-radio"
                                    name="radio{{ authorization.authorizationId }}"
                                    value="true"
                                    [(ngModel)]="model[authorization.authorizationId]"
                                    (change)="changeRadioButton($event, 1)"
                                  />
                                  <span>{{ yes_label }}</span>
                                </label>
                              </div>
                              <div class="col-xs-offset-3">
                                <label>
                                  <input
                                    id="{{ authorization.authorizationId }}"
                                    type="radio"
                                    class="radiobtn form-radio"
                                    name="radio{{ authorization.authorizationId }}"
                                    value="false"
                                    [(ngModel)]="model[authorization.authorizationId]"
                                    (change)="changeRadioButton($event, 1)"
                                  />
                                  <span>{{ no_label }}</span>
                                </label>
                              </div>
                            </div>
                          </div>
                        </ng-container>

                        <!-- Tipo 2: Text area -->
                        <ng-container *ngSwitchCase="2">
                          <div id="tab-{{ authorization.authorizationId }}" #info class="switch-type">
                            <div class="text-left">
                              <label class="text-left col-form-label">
                                {{ decodeHtmlEntities(authorization.authorizationText) }}
                              </label>
                            </div>
                            <textarea
                              id="textarea-{{ authorization.authorizationId }}"
                              [(ngModel)]="model[authorization.authorizationId]"
                              class="form-control textarea-width m-b component-style"
                              rows="3"
                            ></textarea>

                            <div class="text-center m-t" *ngIf="model[authorization.authorizationId]">
                              <button
                                class="btn btn-danger"
                                type="button"
                                id="button-borrar{{ authorization.authorizationId }}"
                                (click)="borrarAuthorization('textarea-' + authorization.authorizationId)"
                              >
                                <i class="fas fa-undo"></i>
                                {{ answer_label }}
                              </button>
                            </div>
                          </div>
                        </ng-container>

                        <!-- Tipo 3: Ranking (estrellas) de 0 a 5 -->
                        <ng-container *ngSwitchCase="3">
                          <div class="text-left switch-type">
                            <label class="text-left col-form-label">
                              {{ decodeHtmlEntities(authorization.authorizationText) }}
                            </label>
                          </div>
                          <div class="col-xs-offset-3 TESTJODERTEST" style="height: 100px">
                            <!-- <bar-rating id="rating-{{ authorization.authorizationId }}" [(ngModel)]="model[authorization.authorizationId]" [max]="5"></bar-rating> -->
                          </div>

                          <div class="text-center" *ngIf="model[authorization.authorizationId]">
                            <button
                              class="btn btn-danger m-t-sm m-b"
                              type="button"
                              id="button-borrar{{ authorization.authorizationId }}"
                              (click)="borrarAuthorization('rating-' + authorization.authorizationId)"
                            >
                              <i class="fas fa-undo"></i>
                              {{ answer_label }}
                            </button>
                          </div>
                        </ng-container>

                        <!-- Tipo 4: Fecha -->
                        <ng-container #info *ngSwitchCase="4">
                          <div id="tab-{{ authorization.authorizationId }}" #info class="switch-type">
                            <div class="text-left">
                              <label class="text-left col-form-label">
                                {{ decodeHtmlEntities(authorization.authorizationText) }}
                              </label>
                            </div>
                            <div class="col-xs-offset-1">
                              <input
                                [(ngModel)]="model[authorization.authorizationId]"
                                type="date"
                                placeholder="Seleccione una fecha"
                                class="form-control m-b-lg"
                                bsDatepicker
                                id="datePicker-{{ authorization.authorizationId }}"
                              />
                            </div>

                            <div class="text-center m-t" *ngIf="model[authorization.authorizationId]">
                              <button
                                class="btn btn-danger m-b"
                                type="button"
                                id="button-borrar{{ authorization.authorizationId }}"
                                (click)="borrarAuthorization('datePicker-' + authorization.authorizationId)"
                              >
                                <i class="fas fa-undo"></i>
                                {{ answer_label }}
                              </button>
                            </div>
                          </div>
                        </ng-container>

                        <!-- Tipo 5: Combo -->
                        <ng-container *ngSwitchCase="5">
                          <div id="tab-{{ authorization.authorizationId }}" #info class="switch-type">
                            <div class="text-left">
                              <label class="text-left col-form-label"> {{ decodeHtmlEntities(authorization.authorizationText) }}</label>
                            </div>
                            <div class="col-xs-offset-1">
                              <select
                                [(ngModel)]="model[authorization.authorizationId]"
                                class="form-control m-b-lg component-style"
                                id="dropdown-{{ authorization.authorizationId }}"
                              >
                                <option [ngValue]="undefined" disabled selected>
                                  {{ selected_options_label }}
                                </option>
                                <option *ngFor="let item of authorization.fixedValue" value="{{ item }}">
                                  {{ item }}
                                </option>
                              </select>
                            </div>

                            <div class="text-center m-t" *ngIf="model[authorization.authorizationId]">
                              <button
                                class="btn btn-danger m-b"
                                type="button"
                                id="button-borrar{{ authorization.authorizationId }}"
                                (click)="borrarAuthorization('dropdown-' + authorization.authorizationId)"
                              >
                                <i class="fas fa-undo"></i>
                                {{ answer_label }}
                              </button>
                            </div>
                          </div>
                        </ng-container>

                        <!-- Tipo 6: Checks con opción multiple -->
                        <ng-container *ngSwitchCase="6">
                          <!-- Opportunity status selector -->
                          <div id="tab-{{ authorization.authorizationId }}" #info class="row form-group switch-type">
                            <div class="text-left">
                              <label class="text-left col-form-label">
                                {{ decodeHtmlEntities(authorization.authorizationText) }}
                              </label>
                            </div>

                            <div #checkbox id="checkbox-{{ authorization.authorizationId }}">
                              <div *ngFor="let menuItem of authorization.fixedValue; let j = index" class="col-xs-offset-3">
                                <input
                                  [(ngModel)]="model['checkbox-' + authorization.authorizationId + '-' + menuItem]"
                                  type="checkbox"
                                  value="{{ menuItem }}"
                                  id="checkbox-{{ authorization.authorizationId }}-{{ menuItem }}"
                                  style="border: 1px solid #5264c4 !important"
                                  (ngModelChange)="
                                    changeCheckBox($event, 'checkbox-' + authorization.authorizationId + '-' + menuItem, 'checkbox-' + authorization.authorizationId + menuItem)
                                  "
                                />
                                <label class="form-check-label" for="checkbox-{{ authorization.authorizationId }}-{{ menuItem }}">
                                  {{ menuItem }}
                                </label>
                              </div>
                            </div>

                            <div class="text-center m-t" *ngIf="model['checkbox-data']">
                              <button
                                class="btn btn-danger"
                                type="button"
                                id="button-borrar{{ authorization.authorizationId }}+'-'+h"
                                (click)="borrarAuthorization('checkbox-' + authorization.authorizationId)"
                              >
                                <i class="fas fa-undo"></i>
                                {{ answer_label }}
                              </button>
                            </div>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- FIRMAS -->
                <div id="signature-container" *ngIf="documents && documents['signatures']" class="mt-2">
                  <!-- Firmas: Contenedor de cada firma. -->
                  <div *ngFor="let oneSignature of documents['signatures']; let i = index">
                    <div>
                      <!-- Titulo.  -->
                      <a (click)="ocultarSignatures($event, oneSignature['signatureId'])">
                        <!-- Titulo.  -->
                        <div class="list-element">
                          <!-- Texto.  -->
                          <ng-container *ngIf="oneSignature['text']" class="col-8 col-md-12 ml-0 pl-0"> {{ decodeHtmlEntities(oneSignature['text']) }}</ng-container>
                          <span *ngIf="oneSignature['required']" class="badge badge-warning sings-required">
                            {{ mandatory_fields_label }}
                          </span>
                          <!-- Icono.  -->
                          <i *ngIf="oneSignature['visible'] === true" class="fa-thin fa-chevron-up fa-x2 iconsize ml-2"></i>
                          <i *ngIf="oneSignature['visible'] === false" class="fa-thin fa-chevron-down fa-x2 iconsize quiter-color ml-2"></i>
                        </div>
                      </a>
                      <!-- Contenedor para la firma.  -->
                      <div [ngClass]="{ oculto: !oneSignature['visible'] }">
                        <div id="{{ oneSignature['signatureId'] }}" class="panel-collapse">
                          <canvas
                            class="signature-component"
                            ejs-signature
                            #signature
                            id="sig-{{ oneSignature['signatureId'] }}"
                            (change)="changeSignature(); setDynamicSize()"
                          ></canvas>
                          <!-- Botón borrar firma del componente.  -->
                          <button
                            id="button-signature-{{ oneSignature['signatureId'] }}"
                            class="btn btn-outline-danger btn-noborder btn-signature"
                            type="button"
                            (click)="clearSignatureComponentById('sig-' + oneSignature['signatureId'])"
                          >
                            <i class="fa-thin fa-eraser"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- SOLO LECTURA  -->
                <div *ngIf="!documents['signatures'] && !documents['authorization']">
                  <h3>{{ 'COMMON.DOCUMENT_NO_SING' | translate }}</h3>
                </div>

                <!-- BLOQUE DE EMAIL Y TELEFONO  -->
                <div id="contact-data" *ngIf="requiereCustomer == 'false'">
                  <form action="#" novalidate="" role="form" class="ng-untouched ng-pristine ng-valid">
                    <!---->
                    <div class="row mt-3">
                      <div style="padding-left: 15px">
                        <!---->
                        <span style="font-size: 15px"> {{ 'INDICATE_EMAIL' | translate }}. </span>
                      </div>
                      <!---->
                      <div class="col-12 col-sm-offset-1" style="width: 100%">
                        <input
                          aria-invalid="false"
                          aria-required="true"
                          class="form-control ng-untouched ng-pristine ng-valid"
                          formcontrolname="email"
                          id="email"
                          name="email"
                          style="font-size: 13px; width: 100%"
                          [(ngModel)]="email"
                          type="text"
                        />
                      </div>
                    </div>

                    <!---->
                    <div class="row mt-3">
                      <div style="padding-left: 15px">
                        <!---->
                        <span style="font-size: 15px"> {{ 'INDICATE_TELEPHONE' | translate }}. </span>
                      </div>
                      <!---->
                      <div class="col-12 col-sm-offset-1" style="width: 100%">
                        <input
                          aria-invalid="false"
                          aria-required="true"
                          class="form-control required email valid ng-untouched ng-pristine ng-valid"
                          formcontrolname="phoneNumber"
                          id="phoneNumber"
                          name="phoneNumber"
                          style="font-size: 13px; width: 100%"
                          [(ngModel)]="phoneNumber"
                          type="text"
                        />
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <!-- BARRA DE MENU INFERIOR.  -->
    <div class="appBottomMenu justify-content-end">
      <!-- Enlace: Continuar  -->
      <a *ngIf="!loadingSendDocuments" id="btn-next" class="item" style="pointer-events: auto; opacity: 1" (click)="changeDocument()">
        <div>
          <!-- Icono  -->
          <i class="fa-light fa-right fa-3x color-primary"></i>
        </div>
      </a>
      <!-- Enlace: Loading  -->
      <a *ngIf="loadingSendDocuments" id="btn-next" class="item" style="pointer-events: auto; opacity: 1">
        <div>
          <!-- Icono  -->
          <i class="fa-light fa-spinner fa-spin fa-3x color-primary"></i>
        </div>
      </a>
    </div>
  </div>

  <!-- PANTALLA FINAL: LISTA DE DESCARGA. -->
  <div class="card card_qsigner" *ngIf="!loadingData && showDownloadScreen">
    <div id="container-documentDownloadlist" class="container animated fadeInDown">
      <!-- Contenido. -->
      <div id="container-documentDownloadlist-content" class="row mt-4">
        <!-- Bloque de cabecera. -->
        <div id="container-documentDownloadlist-content-header" class="col-12 text-center">
          <h2>
            {{ finish_successfully_label }}
          </h2>
          <p>{{ choose_download_document_label }}</p>
        </div>

        <!-- Visualizador del documento -->
        <div class="col-12" *ngIf="hasDocument && showDocumentPdf">
          <div id="container-document-preview-download" class="my-4">
            <!-- Barra de navegación del PDF -->
            <div class="text-center pagination_qsigner my-3">
              <!-- Imprimir. -->
              <button class="btn btn-primary hidden-xs" type="button" (click)="printDocument($event)">
                <i class="fa-thin fa-print"></i>
              </button>
              <div>
                <!-- Página anterior. -->
                <button class="btn btn-primary hidden-xs" type="button" (click)="prevPage()" [disabled]="page === 1 || !page || !totalPages">
                  <i class="fa-thin fa-chevrons-left"></i>&nbsp;
                </button>

                <!-- Paginación. -->
                <button class="btn btn-primary hidden-xs" type="button" disabled>
                  <strong>{{ page }}</strong> / {{ totalPages }}
                </button>

                <!-- Página siguiente. -->
                <button class="btn btn-primary hidden-xs" type="button" (click)="nextPage()" [disabled]="page >= totalPages || !page || !totalPages">
                  <i class="fa-thin fa-chevrons-right"></i>
                </button>
              </div>

              <div>
                <!-- Disminuir zoom. -->
                <button class="btn btn-primary hidden-xs" type="button" (click)="zoom_out()" [disabled]="zoom === 1 || !page || !totalPages">
                  <i class="fa-thin fa-magnifying-glass-minus"></i>
                </button>
                <!-- Aumentar zoom. -->
                <button class="btn btn-primary hidden-xs" type="button" (click)="zoom_in()" [disabled]="zoom === 3 || !page || !totalPages">
                  <i class="fa-thin fa-magnifying-glass-plus"></i>
                </button>
              </div>
            </div>

            <!-- PDF visor inline -->
            <div id="container-pdf-viewer-inline-download">
              <pdf-viewer
                #pdfViewer
                id="pdfViewerInlineDownload"
                [src]="pdfSrc"
                [render-text]="true"
                [safe]="true"
                [original-size]="true"
                [show-all]="false"
                [page]="page"
                [zoom]="zoom"
                [fit-to-page]="true"
                (after-load-complete)="afterLoadComplete($event)"
              ></pdf-viewer>
            </div>
          </div>
        </div>

        <!-- Bloque para la lista de documentos. -->
        <div id="container-documentDownloadlist-content-body" class="col-12 text-center" *ngIf="documentosToDownload.length > 1">
          <!-- Bloque para cada documento de la lista.  -->
          <div *ngFor="let document of documentosToDownload; let i = index" class="row">
            <!-- Etiqueta.  -->
            <label>
              <!-- Checkbox  -->
              <input
                id="file-{{ document.documentId }}"
                type="radio"
                class="radiobtn form-checkbox checkbox-fix component-style quiter-color check-style"
                [(ngModel)]="modelo['file-' + document.documentId]"
                value="{{ i }}"
                (ngModelChange)="changeSelectFiles('file-' + document.documentId)"
              />
              <!-- Texto.  -->
              <p class="document-list-valign">
                {{ document.description }}
              </p>
            </label>
          </div>
        </div>
      </div>
      <!-- BARRA DE MENU INFERIOR PARA LA PANTALLA DE DESCARGA.  -->
      <div class="d-flex justify-content-center mt-4 btns_final">
        <!-- Enlace: Descargar documento.  -->
        <a id="btnDownloadDocument" class="item" style="pointer-events: auto; opacity: 1; width: 20%" (click)="downloadSingDocument($event)">
          <div *ngIf="!loadingDownloadSingDocument">
            <!-- Icono.  -->
            <i class="fa-thin fa-file-arrow-down fa-3x color-primary"></i>
            <br />
            <!-- Texto. -->
            <strong style="font-size: 12px; color: #575757"> {{ download_label }} </strong>
          </div>
          <div *ngIf="loadingDownloadSingDocument">
            <!-- Icono.  -->
            <i class="fa-thin fa-spinner fa-spin fa-3x marginB color-primary"></i>
            <br />
            <!-- Texto. -->
            <strong style="font-size: 12px; color: #575757"> {{ downloading_label }} </strong>
          </div>
        </a>
        <!-- Enlace: Finalizar.  -->
        <a class="item" style="pointer-events: auto; opacity: 1; width: 20%" (click)="close()">
          <div>
            <!-- Icono.  -->
            <i class="fa-thin fa-circle-check fa-3x color-primary"></i>
            <br />
            <!-- Texto. -->
            <strong style="font-size: 12px; color: #575757"> {{ finish_label }} </strong>
          </div>
        </a>
        <!-- Enlace: WhatsAPP.  -->
        <a *ngIf="phoneNumber && requiereCustomer == 'false'" class="item action-buttons" (click)="sendWhatsAppMessageWithQSignerURL()">
          <div>
            <!-- Icono.  -->
            <i class="fa-thin fa-brands fa-whatsapp fa-3x color-primary"></i>
            <br />
            <!-- Texto. -->
            <strong style="font-size: 12px; color: #575757">WhatsApp</strong>
          </div>
        </a>
      </div>
    </div>
    <i class="fa-thin fa-file-contract"></i>
  </div>
</div>
